import { render, staticRenderFns } from "./targetSplit.vue?vue&type=template&id=ab58c62e&scoped=true"
import script from "./targetSplit.vue?vue&type=script&lang=js"
export * from "./targetSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab58c62e",
  null
  
)

export default component.exports